// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xuY0t","secondary":"Button_secondary__qQ6t9"};